<template>
  <div class="pb-xl-6 pb-lg-6 pb-md-2 pb-sm-2 pb-3" v-if="claims">
    <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-0 pt-0 px-xl-4 px-lg-4 px-md-4 px-sm-0 px-0 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters v-if="claims.length > 0">
      <v-col class="pl-5" cols="9" v-if="$vuetify.breakpoint.mdAndUp">
        <div class="mb-4 pr-1 text-right grey--text text--darken-2">
          {{ claims.length }}
          <span v-if="claims.length == 1">Reclamo encontrado</span>
          <span v-else>Reclamos encontrados</span>
        </div>
      </v-col>
      <v-col class="toolbar-quantity" v-else>
        <v-toolbar dense>
          <v-toolbar-title class="subtitle-2 grey--text">{{ claims.length }}
            <span v-if="claims.length == 1">Reclamo encontrado</span>
            <span v-else>Reclamos encontrados</span>
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col xl="8" lg="9" md="11" sm="12" cols="12" :class="$vuetify.breakpoint.mdAndUp ? 'card-border-bottom':  ''">
        <v-card class="mx-auto text-left pb-1 card-border-left card-border-right" v-for="claim in claims" :key="claim.id" tile flat>
          <v-row no-gutters class="card-border-top">
            <v-col class="center-col" xl="2" lg="2" md="2" sm="2" cols="3">
              <v-icon size="60" color="blue" v-if="$vuetify.breakpoint.mdAndUp">feedback</v-icon>
              <v-icon size="50" color="blue"  v-if="$vuetify.breakpoint.smAndDown">feedback</v-icon>
            </v-col>
            <v-col xl="9" lg="9" md="9" sm="9" cols="7" class="px-xl-2 px-lg-2 px-md-2 px-sm-2 px-3 pt-xl-2 pt-lg-2 pt-md-2 pt-sm-1 pt-2 mb-4">
              <div class="text--primary text-left font-weight-light text-lowercase claim-title first-capital-letter mt-2">Reclamo {{ claim.code }}</div>
              <div class="body-2 text-left font-weight-medium">{{ dateFormat(claim.created_at, "ll") }}</div>
              <div class="text-left claim-subtitle body-2 grey--text mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1 mt-1">{{ claim.TypesOfClaim.name }}</div>
              <div class="text-left claim-subtitle body-2 grey--text text--darken-3 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1 mt-1">
                <span v-if="claim.status == 0">Su reclamo esta pendiente</span>
                <span v-if="claim.status == 1">Su reclamo esta en proceso</span>
                <span v-if="claim.status == 2">Reclamo aceptado</span>
                <span v-if="claim.status == 3">Reclamo rechazado</span>
                <span v-if="claim.status == 4">Reclamo cancelado</span>
              </div>
            </v-col>
            <v-col class="center-col pt-xl-5 pt-lg-5 pt-md-5 pt-sm-4 pt-3" xl="1" lg="1" md="1" sm="1" cols="2" align-self="start">
              <v-menu bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-dots-vertical</v-icon>
                </template>

                <v-list class="text-left" dense>
                  <v-list-item @click="goToRouteByName('Purchase-detail', { id: claim.purchase_id })">
                    <v-list-item-icon class="mr-4">
                      <v-icon color="#606060">visibility</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Detalle de compra</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="claim.status == 0 || claim.status == 1" @click="goToRouteByName('Create-claim', { purchase_id: claim.purchase_id })">
                    <v-list-item-icon class="mr-4">
                      <v-icon color="#606060">edit</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Modificar reclamo</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="claim.status == 0 || claim.status == 1" @click="cancelClaim(claim)">
                    <v-list-item-icon class="mr-4">
                      <v-icon color="#606060">highlight_off</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Cancelar reclamo</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="py-8" justify="center" align="center" no-gutters v-else>
      <v-col cols="10">
        <v-icon size="150" color="grey" v-if="$vuetify.breakpoint.mdAndUp">feedback</v-icon>
        <v-icon class="mb-2" size="100" color="grey" v-else>feedback</v-icon>
        <div class="headline font-weight-regular mb-xl-5 mb-lg-5 mb-md-5 mb-sm-4 mb-4 not-found-title">No se encontraron reclamos.</div>
        <div class="mb-xl-1 mb-lg-1 mb-md-1">
          <v-btn class="text-none" color="blue darken-" dark large outlined @click="goToRouteByName('Home')">
            <v-icon left>store</v-icon>Continuar comprando
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <list-loader></list-loader>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import ListLoader from '@/loaders/ListLoader'

export default {
  mixins: [navigationMixin],
  components: {
    ListLoader
  },
  computed: {
    ...mapState('claim', ['claims']),
    ...mapGetters('shared', ['dateFormat'])
  },
  methods: {
    ...mapActions('claim', ['getClaims', 'updateClaim']),
    async cancelClaim (claim) {
      claim.status = 4

      await this.updateClaim(claim)
      if (this.error.status) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: this.error.message })
      }
    }
  },
  mounted () {
    this.getClaims()
  }
}
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .toolbar-quantity{
    margin-bottom: 0.5px;
  }

  .claim-title{
    font-size: 1.25em;
  }

  .center-col{
    display: flex;
    justify-content: center;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .claim-title{
      font-size: 15px;
      line-height: 18px;
    }

    .claim-subtitle{
      font-size: 13px !important;
      line-height: 16px;
    }

    .not-found-title{
      font-size: 16px !important;
      line-height: 24px;
    }
  }
</style>
